import { ReactNode, useEffect, useRef, useState } from 'react';
import ClassString from '@utils/class-string.ts';

interface HorizontalScrollWithArrows {
	children: ReactNode;
	className?: string;
}

const HorizontalScrollWithArrows = (props: HorizontalScrollWithArrows) => {
	const scrollRef = useRef<HTMLDivElement>(null);
	const [isScrollable, setIsScrollable] = useState(false);

	useEffect(() => {
		const checkOverflow = () => {
			if (!scrollRef.current) {
				return;
			}

			const { scrollWidth, clientWidth } = scrollRef.current;
			setIsScrollable(scrollWidth > clientWidth);
		};
		checkOverflow();
		window.addEventListener('resize', checkOverflow);
		return () => window.removeEventListener('resize', checkOverflow);
	}, []);

	const scroll = (direction: number) => {
		if (scrollRef.current) {
			scrollRef.current.scrollBy({
				left: direction * 200,
				behavior: 'smooth',
			});
		}
	};

	return (
		<div
			className={ClassString({
				static: 'w-full inline-flex justify-start items-center gap-2',
				dynamic: {},
				custom: props.className,
			})}
		>
			{isScrollable && (
				<button
					className={
						'rounded-lg h-full p-1 shadow hover:bg-blue-300 hover:text-gray-600 cursor-pointer  outline outline-gray-200 dark:outline-gray-525'
					}
					onClick={() => scroll(-1)}
				>
					{'<'}
				</button>
			)}
			<div
				ref={scrollRef}
				className={
					'flex overflow-x-auto whitespace-nowrap scrollbar-none scroll-smooth no-scrollbar'
				}
			>
				{props.children}
			</div>
			{isScrollable && (
				<button
					className={
						'rounded-md h-full p-1 shadow hover:bg-blue-300 hover:text-gray-600  cursor-pointer outline outline-gray-200 dark:outline-gray-525'
					}
					onClick={() => scroll(1)}
				>
					{'>'}
				</button>
			)}
		</div>
	);
};

export default HorizontalScrollWithArrows;
